export const SESSION_STORAGE_KEY_TOKEN = 'ProgramPMIToken'